export default "__VITE_ASSET__BqTpQtLp__ 778w";